var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import * as moment from 'moment';
import { resetScoreboard, setScoreboardCategory, setScoreboardRound, } from '../reducers/actions';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.css';
import IconQualified from './IconDashboard/IconQualified';
var selfStyles = require('./styles.scss');
var SelectRound = (function (_super) {
    __extends(SelectRound, _super);
    function SelectRound(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChangeRound = _this.handleChangeRound.bind(_this);
        return _this;
    }
    SelectRound.prototype.componentDidMount = function () {
        var event = this.props.workspaceEvent.event;
        var prevRoundId = window.localStorage.getItem("scoreboard-" + (event.id || 'undefined'));
        if (prevRoundId) {
            this.handleChangeRound(prevRoundId);
        }
        else if (!this.props.scoreboard.roundId && this.props.workspaceEvent.rounds.length) {
            var roundId = this.findCurrentRound(this.props.workspaceEvent.rounds);
            this.handleChangeRound(roundId);
        }
    };
    SelectRound.prototype.componentWillReceiveProps = function (nextProps) {
        var prevRoundId = window.localStorage.getItem("scoreboard-" + this.props.workspaceEvent.event.id);
        if (!prevRoundId &&
            !this.props.scoreboard.roundId &&
            nextProps.workspaceEvent.rounds &&
            nextProps.workspaceEvent.rounds[0]) {
            var roundId = this.findCurrentRound(nextProps.workspaceEvent.rounds);
            this.handleChangeRound(roundId);
        }
    };
    SelectRound.prototype.findCurrentRound = function (rounds) {
        var sortedRounds = rounds
            .sort(function (a, b) { return a.dateStart !== b.dateStart
            ? moment(a.dateStart).isBefore(moment(b.dateStart)) ? -1 : 1
            : a.code.localeCompare(b.code); });
        var roundId = undefined;
        sortedRounds.some(function (r) {
            if (moment().isAfter(moment(r.dateStart)) &&
                moment().isBefore(moment(r.dateEnd))) {
                roundId = r.id;
                return true;
            }
            return false;
        });
        return roundId || rounds[0].id;
    };
    SelectRound.prototype.handleChangeRound = function (roundId) {
        var round = this.props.workspaceEvent.rounds.find(function (r) { return r.id === roundId; });
        if (!round) {
            this.props.dispatch(resetScoreboard());
            return;
        }
        var category = this.props.workspaceEvent.categories.find(function (c) { return c.id === round.categoryId; });
        if (!category) {
            this.props.dispatch(resetScoreboard());
            return;
        }
        this.props.dispatch(setScoreboardRound(round.id));
        this.props.dispatch(setScoreboardCategory(category.id));
        var event = this.props.workspaceEvent.event;
        window.localStorage.setItem("scoreboard-" + event.id, roundId);
    };
    SelectRound.prototype.render = function () {
        var _this = this;
        return (React.createElement(Select, { size: 'large', className: selfStyles.select, onChange: this.handleChangeRound, value: this.props.scoreboard.roundId, notFoundContent: 'See the scores for a round', placeholder: 'See the scores for a round' }, this.props.workspaceEvent.rounds
            .sort(function (a, b) { return a.dateStart !== b.dateStart
            ? moment(a.dateStart).isBefore(moment(b.dateStart)) ? -1 : 1
            : a.index !== b.index
                ? a.index - b.index
                : a.code !== b.code
                    ? a.code.localeCompare(b.code)
                    : a.name.localeCompare(b.name); })
            .map(function (r) {
            var category = _this.props.workspaceEvent.categories.find(function (c) { return c.id === r.categoryId; });
            return (React.createElement(Select.Option, { key: r.id, value: r.id },
                r.isScoresFinalized ? React.createElement(IconQualified, null) : null,
                " ",
                r.code,
                " - ",
                r.name,
                category && ", " + category.name));
        })));
    };
    return SelectRound;
}(React.Component));
var mapStateToProps = function (state) { return ({
    scoreboard: state.scoreboard,
    workspaceEvent: {
        event: state.workspaceEvent.event && state.workspaceEvent.event.data[0],
        categories: state.workspaceEvent.categories && state.workspaceEvent.categories.data,
        rounds: state.workspaceEvent.rounds && state.workspaceEvent.rounds.data,
    },
}); };
export default connect(mapStateToProps)(SelectRound);



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/SelectRound.tsx
// module id = 639
// module chunks = 0